<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

import { getToken } from "@/utils/auth";
export default {
  name: 'App',
  data() {
    return {
      ws: null,
      url: '',
      st: null,
    };
  },
  created() { 
    // this.startWebsocket();
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue